import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import { styled } from '@mui/material/styles';
import React, { useState, useEffect } from 'react';
import { SketchPicker } from 'react-color';
import TextInput from './TextInput';

const Swatch = styled('div')`
  width: 20px;
  height: 20px;
  background-color: ${(props) => props.color || '#939393'};
  border-radius: 50%;
  cursor: pointer;
`;

const StyledRoot = styled(FormControl)`
  position: relative;
`;

export default ({
  value,
  onChange,
  size,
  label,
  hint,
  hasError,
  helpText,
  rounded,
  hideValue = false,
  fullWidth,
  margin = 'none',
}) => {
  const [showPicker, setShowPicker] = useState(false);
  const [color, setColor] = useState(value);
  const togglePicker = () => setShowPicker(!showPicker);
  const hidePicker = () => setShowPicker(false);
  const [text, setText] = useState(value);

  useEffect(() => {
    // check if the value is a valid hex color then set the color
    if (/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(text)) {
      handleChange({ hex: text });
    } else if (!text) {
      handleChange({ hex: '#000000' });
    }
  }, [text]);

  useEffect(() => {
    setColor(value);
    setText(value);
  }, [value]);

  const handleChange = ({ hex }) => {
    setColor(hex);
    onChange && onChange(hex);
  };

  const popover = {
    position: 'absolute',
    zIndex: '2',
  };
  const cover = {
    position: 'fixed',
    top: '0px',
    right: '0px',
    bottom: '0px',
    left: '0px',
  };

  return (
    <StyledRoot fullWidth={fullWidth} error={hasError} margin={margin}>
      <TextInput
        onChange={(e) => setText(e.target.value)}
        value={text}
        label={label}
        placeholder="Select Color"
        startAdornment={<Swatch color={value} onClick={togglePicker} />}
      />
      {showPicker ? (
        <div style={popover}>
          <div style={cover} onClick={hidePicker} />
          <SketchPicker
            disableAlpha={true}
            onChange={handleChange}
            color={color}
          />
        </div>
      ) : null}
      {hasError && (
        <FormHelperText error sx={{ m: 0 }}>
          {helpText}
        </FormHelperText>
      )}
    </StyledRoot>
  );
};
